module.exports = __webpack_public_path__ + "static/img/business777.c6c5384.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business777.png
// module id = ia/x
// module chunks = 9